import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import "./PaymentLayout.css";
import { useSelector } from "react-redux";
import { Formik, Form as FORM, Field, ErrorMessage } from "formik";
import PaymentCancel from "./PaymentCancel";
import "./PaymentLayout.css"
import { useTranslation } from "react-multi-lang";

const PhonePePayment = (props) => {
  const t = useTranslation("payin_one");

  const [show, setShow] = useState(false);

  const transactionView = useSelector((state) => state.payment.transactionView);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  console.log("paymentData", props.paymentData);

  return (
    <>
      <div className="snapgopay-payment-form-wrap">
        <div className="snapgopay-form-wrap-top">
          <div className="form-heading">
            <h2>{t("heading")}</h2>
          </div>
          <div className="snapgopay-total-amount-frame">
            <p>{t("total")} :</p>
            <h3>{transactionView.data.transaction.formatted_total}</h3>
            <span></span>
          </div>
        </div>
        <div className="middle-wrap">
          <div className="snapgopay-form-wrap-middle">
            <div className="snapgopay-pay-method-info">
              <p>{t("payment_method")}</p>
              <h4>{transactionView.data.transaction.payment_type_formatted}</h4>
            </div>
            {transactionView.data.transaction.inr_type ? <div className="snapgopay-pay-method-info">
              <p>{t("inr_type")}</p>
              <h4>{transactionView.data.transaction.inr_type_formatted}</h4>
            </div> : null}
            <div className="snapgopay-pay-method-info">
              <p>{t("order_id")}</p>
              <h4>{transactionView.data.transaction.order_id}</h4>
            </div>
          </div>
          <div className="snapgopay-form-wrap-bottom website-hide">
            <Formik >
              {({ values, setFieldValue }) => (
                <FORM>
                  <div className="form-wrap-btn">
                    <Button
                      type="button"
                      className="btn-cancel"
                      onClick={handleShow}
                    >
                      Cancel
                    </Button>

                    <a
                      className="btn-next phonepe-payment-btn"
                      href={props.paymentData.payment_details.intent_url ? props.paymentData.payment_details.intent_url.replace("upi://", "phonepe://") : "#"}
                      // disabled={transactionUpdate.buttonDisable || checkPaymentMethod.buttonDisable}
                    >
                      {"Pay Now"}
                    </a>
                  </div>
                </FORM>
              )}
            </Formik>
            {show && <PaymentCancel show={show} handleClose={handleClose} />}
          </div>

          <div className="upi-payment-box mobile-hide">
                      <h4>Open in mobile browser for completing the order</h4>
                    </div>
        </div>
      </div>
    </>
  );
};

export default PhonePePayment;
